module.exports = __webpack_public_path__ + "img/BOCGreek1990.c7ccc0f3.jpg";